import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import { Card } from "../../../components/Card";
import { Button } from "../../../components/CTA";
import { H3 } from "../../../components/Heading";
import Loading from "../../../components/Loading";
import { Text } from "../../../components/Text";
import { View } from "../../../components/View";
import {
  useBrandBillingQuery,
  useCreateStripePortalMutation,
} from "../../../graphql/generated";
import useGqlClient from "../../../hooks/useGqlClient";
import { authSelectors } from "../../../store/auth/selector";
import styled from "../../../styles";

export const Billing = () => {
  const client = useGqlClient();
  const createStripePortal = useCreateStripePortalMutation(client);
  const activeBrandId = useSelector(authSelectors.activeBrandId);

  const { data, isLoading } = useBrandBillingQuery(
    client,
    {
      brandID: activeBrandId ? activeBrandId : "",
    },
    {
      enabled: activeBrandId !== "",
    }
  );

  if (isLoading || !data) {
    return <Loading />;
  }

  if (data && data.brand && !data.brand.stripeCustomerId) {
    return <Redirect to="/b/billing" />;
  }

  return (
    <StyledCard>
      <H3 margin="0 0 m">Billing</H3>
      <Wrap>
        <View style={{ flex: 1 }} margin="0 m 0 0">
          <Text weight="bold" margin="0">
            Use our billing portal to manage your account
          </Text>
          <Text size="s" margin="0" colorPreset="secondary">
            View invoices, update payment methods and change your billing email.
          </Text>
        </View>
        <View>
          <Button
            size="s"
            onClick={() =>
              createStripePortal.mutate(
                {},
                {
                  onSuccess: (res: any) => {
                    window.location.href = res.createStripePortal.redirectUrl;
                  },
                  onError: () => {
                    alert("Something went wrong");
                  },
                }
              )
            }
          >
            {createStripePortal.isLoading ? "Loading..." : "Go to portal"}
          </Button>
        </View>
      </Wrap>
    </StyledCard>
  );
};

const Wrap = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  background-color: ${(p) => p.theme.color.card.callout};
  border-radius: ${(p) => p.theme.misc.borderRadius};
  padding: ${(p) => p.theme.spacing.l};
  box-sizing: border-box;
  align-items: center;
`;

const StyledCard = styled(Card)`
  margin: 1px;
  margin-top: ${(p) => p.theme.spacing.l};
  padding: ${(p) => p.theme.spacing.l};
`;
